import { render } from "./PiaProductDialog.vue?vue&type=template&id=7bea28bd&scoped=true"
import script from "./PiaProductDialog.vue?vue&type=script&lang=js"
export * from "./PiaProductDialog.vue?vue&type=script&lang=js"

import "./PiaProductDialog.vue?vue&type=style&index=0&id=7bea28bd&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea28bd"]])

export default __exports__